<template>
  <div>
    <v-card color="grey lighten-4" flat tile>
      <v-toolbar :color="tema.topbar">
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          color="white"
        ></v-app-bar-nav-icon>
        <v-toolbar-title class="titulo-empresa" @click="linkDashboard()">
          <img
            :src="empresa.logo_header"
            class="img-empresa-header"
            width="230"
          />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          v-if="!ehAdmin && temMultiplosCandidatos"
          :value="candidatoAtivoId"
          :items="listaCandidatos"
          item-text="nome_completo"
          item-value="idcandidato"
          label="Equipe"
          dense
          hide-details
          outlined
          dark
          class="select-candidato mr-3"
          style="max-width: 260px"
          @change="trocarCandidato"
        ></v-select>
        <v-chip
          v-if="parceiraAtiva"
          small
          color="green darken-1"
          text-color="white"
          class="mr-2 chip-parceira"
          title="Cadastros novos serão replicados automaticamente para a base parceira."
        >
          <v-icon left x-small>mdi-link-variant</v-icon>
          Modo unificado<span v-if="parceiraNome">: {{ parceiraNome }}</span>
        </v-chip>
      </v-toolbar>
    </v-card>
    <v-navigation-drawer
      v-model="drawer"
      :width="325"
      absolute
      temporary
      class="drawer-menu"
    >
      <v-btn icon @click.stop="drawer = !drawer">
        <v-icon color="#000" class="icon-close">mdi-close</v-icon>
      </v-btn>
      <v-list-item-content
        class="text-center"
        style="padding-top: 0px; margin-top: -5px"
      >
        <v-img
          contain
          max-height="100"
          :src="empresa.logo"
          class="img-empresa"
          width="100"
        ></v-img>
        <p>Versão : {{ app_version }}</p>
        <h3 class="titulo-nome">{{ usuarioLogado.nome }}</h3>
        <p class="titulo-cargo">{{ usuarioLogado.setor }}</p>
      </v-list-item-content>
      <v-divider></v-divider>
      <div class="drawer-modulos">
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="list-item" @click="alterarSenhaDialog">
              <v-list-item-icon style="margin: 0 13% 0 0">
                <v-icon>mdi-key</v-icon> </v-list-item-icon
              >Alterar Senha
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="list-item" @click="linkDashboard">
              <v-list-item-icon style="margin: 0 13% 0 0">
                <v-icon>mdi-home</v-icon> </v-list-item-icon
              >Dashboard
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list>
          <v-list-group
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  v-text="item.title"
                  class="list-item"
                ></v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="subItem in item.items"
              :key="subItem.title"
              @click="linkRota(subItem.url, subItem.rota)"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-text="subItem.title"
                  class="list-item"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </div>

      <template v-slot:append>
        <v-divider></v-divider>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="list-item-sair" @click="Helpers.logout()">
              <v-list-item-icon style="margin: 0 13% 0 0">
                <v-icon>mdi-logout</v-icon> </v-list-item-icon
              >Sair
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <!-- Dialog de Senha -->
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Alterar Senha</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="password"
                  :error-messages="passwordErrors"
                  autofocus
                  outlined
                  label="Nova Senha*"
                  type="password"
                  autocomplete="new-password"
                  @input="$v.password.$touch()"
                  @blur="$v.password.$touch()"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model.trim="repeatPassword"
                  :error-messages="repeatPasswordErrors"
                  outlined
                  label="Confirmar Senha*"
                  type="password"
                  @input="$v.repeatPassword.$touch()"
                  @blur="$v.repeatPassword.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small>* Indica Campos Obrigatórios</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Sair</v-btn>
          <v-btn text @click="alterarSenha">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Relatorios -->
    <v-dialog v-model="dialogRelatorio" persistent max-width="450px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Relatório
            <span v-if="relatorio === 'relatorio_excesso'"
              >Excesso de Estoque</span
            >
            <span v-if="relatorio === 'relatorio_oportunidade_venda'"
              >Oportunidade de Venda</span
            >
            <span v-if="relatorio === 'relatorio_percepcao_compras'"
              >Percepção de Compras</span
            >
            <span v-if="relatorio === 'relatorio_curva_abc'">Curva ABC</span>
          </span>
        </v-card-title>
        <v-card-text style="padding-bottom: 0">
          <v-container style="padding-bottom: 0">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="gruposRelatorio.id"
                  :items="gruposRelatorio"
                  label="Selecione o Grupo"
                  item-text="descricao"
                  item-value="id"
                  height="10"
                  outlined
                  chips
                  @change="buscarFiliais()"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="selects.filial.value"
                  :items="selects.filial.items"
                  label="Selecione a Filial"
                  item-value="filial"
                  item-text="filial"
                  height="10"
                  outlined
                  chips
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                v-if="relatorio === 'relatorio_oportunidade_venda'"
              >
                <v-select
                  v-model="selects.anos.value"
                  :items="selects.anos.items"
                  label="Selecione um ano"
                  item-value="ano"
                  item-text="ano"
                  height="10"
                  outlined
                  chips
                ></v-select>
              </v-col>
              <v-col
                cols="6"
                v-if="relatorio === 'relatorio_percepcao_compras'"
              >
                <v-text-field
                  v-model="dataInicial"
                  label="Data Inicial"
                  height="10"
                  type="date"
                  outlined
                  chips
                ></v-text-field>
              </v-col>
              <v-col
                cols="6"
                v-if="relatorio === 'relatorio_percepcao_compras'"
              >
                <v-text-field
                  v-model="dataFinal"
                  label="Data Final"
                  height="10"
                  type="date"
                  outlined
                  chips
                  :error-messages="
                    erroData ? 'Data final inferior a inicial.' : ''
                  "
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  relatorio === 'relatorio_excesso' ||
                  relatorio === 'relatorio_curva_abc'
                "
              >
                <v-autocomplete
                  v-model="selects.fornecedores.value"
                  :items="selects.fornecedores.items"
                  label="Selecione o Fornecedor"
                  item-text="razao_social"
                  item-value="idfornecedor"
                  outlined
                  clearable
                ></v-autocomplete>

                <v-checkbox
                  v-if="relatorio === 'relatorio_curva_abc'"
                  style="margin-bottom: 20px; margin-top: -10px"
                  v-model="saldoVendaEstoque"
                  label="Processar os saldos  de venda e estoque  semestral"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" style="margin-top: -40px">
                <v-radio-group
                  v-model="extensaoRelatorio"
                  row
                  v-if="!saldoVendaEstoque"
                >
                  <v-radio label="PDF" value="pdf"></v-radio>
                  <v-radio label="Excel" value="excel"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding-top: 0">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogRelatorio = false">Sair</v-btn>
          <v-btn text @click="gerarRelatorio(relatorio)">Gerar Relatório</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import UsuarioAPI from "./../../api/usuario";
import { mapGetters } from "vuex";
import { temaAtual } from "@/themes/equipes";

export default {
  data() {
    return {
      gruposRelatorio: [],
      dialog: false,
      relatorio: "",
      dialogRelatorio: false,
      password: "",
      repeatPassword: "",
      app_version: process.env.VUE_APP_VERSION,

      dataInicial: "",
      dataFinal: "",
      extensaoRelatorio: "excel",
      saldoVendaEstoque: false,

      empresa: {
        nome: "InfoGuest",
        logo: require("../../assets/logo_menu.png"),
        logo_header: require("../../assets/logo_header.png"),
      },

      usuarioLogado: {
        nome: localStorage.getItem("nome"),
        cargo: "",
        setor: "",
      },

      drawer: null,
      items: [],

      selects: {
        grupos: {
          items: [],
          value: "",
        },

        filial: {
          items: [{ filial: "Todas" }],
          value: [],
        },
        filiais_compra: {
          items: [{ id: 0, descricao: "Geral", filial: "0" }],
          value: [],
        },

        anos: {
          items: [],
          value: "",
        },

        fornecedores: {
          items: [],
          value: "",
        },
      },
    };
  },

  validations: {
    password: {
      required,
      minLength: minLength(6),
    },
    repeatPassword: {
      sameAsPassword: sameAs("password"),
    },
  },

  computed: {
    ...mapGetters({
      grupoCompras: "usuario/getGrupoCompras",
      grupos: "usuario/getGrupos",
      filialCompras: "usuario/getFilialCompras",
      exibeFilialCompra: "usuario/getExibeFilialCompra",
      candidatoAtivoId: "candidato_ativo/idcandidato",
      listaCandidatos: "candidato_ativo/lista",
      temMultiplosCandidatos: "candidato_ativo/temMultiplos",
    }),

    tema() {
      return temaAtual();
    },

    // Admin (perfil 1/2) escolhe a equipe dentro de cada tela; nao usa o seletor do topo.
    ehAdmin() {
      return parseInt(localStorage.getItem("controle"), 10) <= 2;
    },

    licenciamento() {
      return localStorage.getItem("empresa");
    },

    parceiraAtiva() {
      return localStorage.getItem("parceira_ativa") === "1";
    },

    parceiraNome() {
      return localStorage.getItem("parceira_nome") || "";
    },

    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("A senha deve ser maior que 6 caracteres");
      !this.$v.password.required && errors.push("Campo Obrigatório.");
      return errors;
    },

    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword &&
        errors.push("As senhas devem ser iguais.");
      return errors;
    },

    erroData() {
      if (
        this.dataInicial > this.dataFinal &&
        this.dataFinal != 0 &&
        this.dataFinal != ""
      )
        return true;
      else return false;
    },
  },

  created() {
    const setor = localStorage.getItem("setor");
    this.usuarioLogado.setor = setor;

    this.getAcessos();

    // Carrega os candidatos atendidos pelo usuario logado (seletor de candidato ativo).
    this.$store.dispatch("candidato_ativo/carregarMeusCandidatos");
  },

  watch: {},

  methods: {
    // Troca o candidato ativo e recarrega para que todas as telas releiam o
    // candidato (localStorage.equipe + Vuex) de forma consistente.
    trocarCandidato(idcandidato) {
      const candidato = (this.listaCandidatos || []).find(
        (c) => String(c.idcandidato) === String(idcandidato)
      );
      this.$store.dispatch(
        "candidato_ativo/setCandidato",
        candidato || { idcandidato }
      );
      window.location.reload();
    },

    getAcessos() {
      const headers = this.Helpers.iniciarRequisicao();

      UsuarioAPI.getAcessos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            if (response.data.acessos.length === 0) {
              alert("Usuário sem Permissão de Acesso!!!");
              this.Helpers.logout();
            }
            this.items = [];
            this.items = response.data.acessos;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    alterarSenha() {
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          password: this.password,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.updatePass(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.dialog = false;
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    alterarSenhaDialog() {
      this.password = "";
      this.repeatPassword = "";
      this.dialog = true;
    },

    linkDashboard() {
      const acesso = localStorage.getItem("controle");
      const service = localStorage.getItem("service");

      if (acesso == 5) {
        this.$router.push({ name: "cadastro_pessoas" });
      } else if (acesso == 4) {
        this.$router.push({ name: "cadastro_assessores" });
      } else if (acesso == 2 && service == "N") {
        this.$router.push({ name: "dashboard_geral" });
      } else if (acesso == 2 && service == "S") {
        this.$router.push({ name: "cadastro_candidatos" });
      } else {
        this.$router.push("/dashboard");
      }
    },

    linkRota(url, rota) {
      if (rota) {
        this.$router.push(url);
      } else if (
        url === "relatorio_ressuprimento_abaixo" ||
        url === "relatorio_ressuprimento"
      ) {
        window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
      } else {
        this.relatorio = url;
        this.dialogRelatorio = true;

        if (url === "relatorio_excesso" || url === "relatorio_curva_abc") {
          this.buscarFornecedores();
        }
      }
    },
  },
};
</script>
<style scoped>
/* Menu lateral: ocupa a tela toda; lista de módulos rola e "Sair" (append) fica fixo no rodapé. */
.drawer-menu {
  height: 100vh !important;
}
.drawer-menu ::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}
.drawer-modulos {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.header-toolbar {
  height: 4em;
}

.titulo-empresa {
  color: #fff;
  cursor: pointer;
}

.img-empresa-header {
  padding: 3% 5% 5% 5%;
  margin-top: 5%;
  margin-left: -15%;
}

.img-empresa {
  padding: 0% 5% 0% 5%;
}

.img-profile {
  padding: 0% 35% 0% 35%;
  border-radius: 50%;
}

.titulo-nome {
  color: #042333;
  font-size: 20px;
}

.titulo-cargo {
  color: #042333;
  font-size: 16px;
}

.list-item {
  color: #042333;
  font-size: 14px;
  padding-left: 0px;
}

.list-item-sair {
  color: #042333;
  font-size: 14px;
}

.chip-parceira {
  font-weight: 600;
  letter-spacing: 0.3px;
}
</style>
